const calendarChipsToggles = {
  actions: 'ACCIONES',
  services_performed: 'SERVICIOS REALIZADOS',
  services_to_be_performed: 'SERVICIOS A REALIZAR / VENCIDOS',
  maintenances: 'MANTENIMIENTOS',
  future_services: 'SERVICIOS FUTUROS',
};

export default calendarChipsToggles;
